import styled from 'styled-components'

export const ActivityItem = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(228, 228, 228, 0.3);
  border-top: 1px solid rgba(228, 228, 228, 0.3);

  .description_text {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.x3};
    color: ${({ theme }) => theme.colors.navyBlue};
    line-height: 20px;
  }

  .date_text {
    font-size: 13px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.contestPrimary};
  }
`

export const ImageContainer = styled.div`
  background: rgba(0, 211, 255, 1);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextWrapper = styled.div`
  margin-left: 20px;

  p {
    margin: 0;
    padding: 5px 0;
  }
`
